import { v7 as Uuid } from 'uuid';
import { configLoader } from '../config/configLoader';
import { createHeaders, handleException, handleResponse } from './util/helper';

let config;

// Hilfsfunktion zum Abrufen der aktuellen Konfiguration
const getConfig = async () => {
  if (!config) config = await configLoader.loadConfig();
  return config;
};

const publicPath = (await getConfig()).PUBLIC_PATH;

export const applicationService = {
  /**
   * Erzeugt eine neue UUID
   */
  generateApplicationId() {
    return Uuid();
  },

  /**
   * Lädt die Konfigurationsdaten für Zusatzbausteine und Zahlungsintervalle
   */
  async requestOptIn(applicationId, application) {
    try {
      const response = await fetch(`${publicPath}api/application/temp/${applicationId}`, {
        body: JSON.stringify(application),
        method: 'POST',
        headers: createHeaders(),
      });

      return await handleResponse(response);
    } catch (error) {
      return handleException(error);
    }
  },

  async acceptOptIn(applicationId, doiCode, email, sessionId) {
    try {
      const body = { sessionId: sessionId, email: email, optInCode: doiCode };

      const response = await fetch(`${publicPath}api/application/temp/${applicationId}`, {
        method: 'PATCH',
        body: JSON.stringify(body),
        headers: createHeaders(),
      });

      return await handleResponse(response);
    } catch (error) {
      return handleException(error);
    }
  },

  async prepareQualifiedApplication(applicationId, application, sessionId) {
    try {
      const response = await fetch(`${publicPath}api/application/${applicationId}`, {
        method: 'POST',
        body: JSON.stringify(application),
        headers: createHeaders({
          'X-Session-ID': sessionId,
        }),
      });

      return await handleResponse(response);
    } catch (error) {
      return handleException(error);
    }
  },

  async signQualifiedApplication(applicationId, application, sessionId) {
    try {
      const response = await fetch(`${publicPath}api/application/${applicationId}`, {
        method: 'PUT',
        body: JSON.stringify(application),
        headers: createHeaders({
          'X-Session-ID': sessionId,
        }),
      });

      return await handleResponse(response);
    } catch (error) {
      return handleException(error);
    }
  },
};
